export function urlencodePhoneNumber(phoneNumber: string | undefined): string {
  const encodedPhoneNumber = encodeURIComponent(String(phoneNumber)).replace('+', '+')
  return encodedPhoneNumber
}
